module.exports = __webpack_public_path__ + "img/car_00014.58fce002.jpg";